/**
 * Обрезает URL в начале (http:// или https://) и в конце ( / );
 * @param {string} val - строка, которую нужно обрезать
 */
export default function strippedUrl(val) {
  let regexp = /^https?:\/\/|\/$/g;
  return val.replace(regexp, "");
}
